import Link from 'next/link';
import { MouseEvent, useEffect } from 'react';
import { ChevronRightIcon } from '@heroicons/react/outline';
import { BookChapter } from '../../lib/guideBooks';
import { BookSocial } from './BookSocial';

type Props = {
  chapters: BookChapter[];
  bookTitle: string;
};

export const BookSidebar = ({ chapters, bookTitle }: Props) => {
  useEffect(() => {
    if (window?.location?.hash) {
      const hash = window.location.hash;
      handleChapterClick(null, decodeURIComponent(hash).replace('#', ''));
    }
  }, []);

  const handleChapterClick = (e: MouseEvent, id: string) => {
    const elem = document.getElementById(id);

    if (elem) {
      window.scroll({ top: elem?.offsetTop - 150, behavior: 'smooth' });
    }
  };

  return (
    <div className="guide-book-sidebar sticky top-[120px] mt-6 flex flex-col space-y-6">
      <BookSocial title={bookTitle} />

      <div className="chapters">
        <h5 className="h5 mb-4">In this guide</h5>

        <ul className="chapter-list">
          {chapters.map((chapter) => {
            return (
              <li key={chapter.title} className="item mb-2">
                <Link
                  href={`#${chapter.displayTitle}`}
                  scroll={false}
                  onClick={(e) => handleChapterClick(e, chapter.displayTitle)}
                  className="flex items-center space-x-2 text-black/90 underline-offset-4 transition-colors hover:text-black/70 hover:underline">

                  <ChevronRightIcon
                    className="icon flex-shrink-0 text-black/50"
                    strokeWidth={3}
                  />
                  <p className="p-small">{chapter.displayTitle}</p>

                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};
